import { pageTypes } from 'common/constants/pageTypes'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import { WebsitePage } from 'publisher/pages/website-page'

export const createPage = (type: keyof typeof pageTypes | PageTypeEnum) => {
  switch (type) {
    case PageTypeEnum.WebsiteDefault:
    case PageTypeEnum.WebsiteLayout:
    case PageTypeEnum.WebsiteHome:
      return WebsitePage
    default:
      // @TODO doesnt' work, window is not defined
      window.Rollbar?.error(`unknown page type ${type}`)
      return null
  }
}
